<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>结算账户</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-box">
            <div class="detail-item">
                <div class="item-title">
                    {{ ($route.query.handler*1===1) ? '修改' : '设置' }}结算帐户信息
                </div>
                <div class="form-box">
                    <el-form
                        class="form__center"
                        label-width="82px"
                        size="small"
                        style="width: 360px;margin: 0 auto;"
                    >
                        <el-form-item label="开户名称：">
                            {{ info.company }}
                        </el-form-item>
                        <el-form-item label="开户银行：">
                            <el-input
                                v-model="formItem.bank_name"
                                placeholder="请输入开户银行"
                            />
                        </el-form-item>
                        <el-form-item label="开户城市：">
                            <el-input
                                v-model="formItem.bank_city"
                                placeholder="广东省广州市"
                            />
                        </el-form-item>
                        <el-form-item label="开户支行：">
                            <el-input
                                v-model="formItem.bank_addr"
                                placeholder="请输入开户支行"
                            />
                        </el-form-item>
                        <el-form-item label="银行账号：">
                            <el-input
                                v-model="formItem.bank_card"
                                placeholder="请输入银行账号"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                class="btn-standard"
                                type="primary"
                                @click="onSubmit"
                            >
                                确认{{ ($route.query.handler*1===1) ? '修改' : '设置' }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Main',
    data () {
        return {
            info: {},
            formItem: {
                bank_name: '',
                bank_addr: '',
                bank_city: '',
                bank_card: ''
            }
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.bank_name': {
            test: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: '请输入开户银行'
        },
        'formItem.bank_addr': {
            test: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: '请输入开户支行'
        },
        'formItem.bank_city': {
            test: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: '请输入开户城市'
        },
        'formItem.bank_card': {
            test: /^[\s\S]*.*[^\s][\s\S]*$/,
            message: '请输入银行账号'
        }
    },
    mounted () {
        this.getInfo()
    },
    methods: {
        getInfo () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                        if (this.$route.query.handler * 1 === 1) {
                            this.loadData()
                        }
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        loadData () {
            let { bankName, bankAddr, bankCity } = this.info
            this.formItem = {
                bank_name: bankName,
                bank_addr: bankAddr,
                bank_city: bankCity
            }
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/bankedit', qs.stringify(this.formItem))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '结算账户信息更新成功'
                            })
                            router.replace('/index/info')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub";

    .form-box {
        border-top: 1px solid $--color-border-base;
        margin-top: 0 !important;
    }
</style>
